// extracted by mini-css-extract-plugin
export default {"board":"ChessBoard_board__Gsi+6"};